var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('home-nav'),_vm._v(" "),_c('home-header'),_vm._v(" "),_c('div',{attrs:{"id":"app"}},[_c('router-view')],1),_vm._v(" "),_c('home-footer'),_vm._v(" "),_c('page-side'),_vm._v(" "),_c('msg-modal')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.2@vue-loader/lib/template-compiler?{"id":"data-v-6c2f93c0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.2@vue-loader/lib/selector.js?type=template&index=0!./src/app.vue
// module id = mJad
// module chunks = 5